module.exports = {"320671001":"中兴街道","320671002":"新开街道","320671003":"竹行街道","320671004":"小海街道","320671400":"江海镇区","320671401":"南通市富民港良种场","320671402":"南通市富民港种畜场","320671403":"南通苏通科技产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320671.json
// module id = 880
// module chunks = 0